import { findDOMNode } from 'react-dom';
import { TimelineLite, Elastic, TweenLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import '../../plugins/debug.addIndicators';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

export default {

    initialise(container) {
        this.tl = new TimelineLite();
        this.node = findDOMNode(container);
        this.textItems = [...this.node.querySelectorAll('.item > span')];
        this.handOpen = [...this.node.querySelectorAll('.hand-open')];
        this.handRock = [...this.node.querySelectorAll('.hand-rock')];
    },

    animateIn(container, currentTarget, changeState, setProgress, currentState) {
        this.initialise(container);
        
        let tl = new TimelineLite();

        if (currentState === 'closed') {
        	setProgress();
            tl.addLabel('slideIn');
            tl.to(this.node, 1.2, {width: '210px', ease: Elastic.easeOut.config(1.1, 0.5)}, 'slideIn');
            tl.staggerFromTo(this.textItems, 0.2, {x: 30, autoAlpha: 0, display: 'inline-block'}, {x: 0, autoAlpha: 1}, 0.1, 'slideIn');
            tl.add(() => this.animateHoverIn(currentTarget), '-=0.8');
            tl.to(this.handOpen, 0.25, {x: 36}, 'slideIn');
            tl.add(() => {
                let tl = new TimelineLite();
                tl.set(this.handOpen, {x: 36});
                tl.to(this.handRock, 0.5, {x: -34});
                tl.to(this.handRock, 0.1, {rotation: 15});
                tl.to(this.handRock, 0.1, {rotation: -15});
                tl.to(this.handRock, 0.1, {rotation: 15});
                tl.to(this.handRock, 0.1, {rotation: -15});
                tl.to(this.handRock, 0.1, {rotation: 15});
                tl.to(this.handRock, 0.1, {rotation: 0});
                tl.to(this.handRock, 0.4, {x: -36}, 0.7);
            }, '-=1');
			tl.add(() => {
				changeState();
			});
        } else {
            this.animateHoverIn(currentTarget);
        }
    },

    animateOut(container, changeState, setProgress) {
        this.initialise(container);
        let reversedItems = this.textItems.slice().reverse();
        let tl = new TimelineLite();

        if (!this.node.classList.contains('closed') && !this.node.classList.contains('progress')) {
        	setProgress();
            tl.staggerTo(reversedItems, 0.2, {x: 30, autoAlpha: 0, display: 'none'}, 0.1);
            tl.to(this.node, 0.6, {width: '70px'}, 0);
            tl.add(() => this.resetHoverStates());
            tl.to(this.handRock, 0.25, {x: 0}, 0);
            tl.to(this.handOpen, 0.5, {x: 0}, '-=0.5');
			tl.add(() => {
				changeState();
			});
        }
    },

    animateHoverIn(target) {
    	if (target.classList.contains('progress')) {
    		return;
		}

        let clone = target.getElementsByClassName('item-clone')[0];

        TweenLite.to(clone, 0.25, {height: '100%'});
    },

    animateHoverOut(container, target) {
        this.initialise(container);
        let clone = target.getElementsByClassName('item-clone')[0];

        TweenLite.to(clone, 0.25, {height: 0});
    },

    resetHoverStates() {
        let clones = [...this.node.getElementsByClassName('item-clone')];

        clones.forEach(item => {
            TweenLite.set(item, {height: 0});
        });
    },

	scrollToSection(sectionId, onComplete) {
    	let section = document.getElementById(sectionId),
			offset = 0;

    	if (sectionId === 'what-i-do') {
    		offset = 350;
		}

    	let tl = new TimelineLite();
    	tl.add(() => {
    		this.resetItems();
    		this.resetLines();
		});
    	tl.to(document.querySelectorAll('section'), 0.1, {opacity: 0});
		tl.to(window, 0.25, {scrollTo: {y: section, offsetY: offset}});
		tl.to(document.querySelectorAll('section'), 0.25, {opacity: 1});
		tl.add(onComplete);
	},

	resetItems() {
		let items = document.querySelectorAll('nav .items a');
		items.forEach(item => {
			item.classList.remove('active');
		});

		return items;
	},

	resetLines() {
		let lines = document.querySelectorAll('nav .progress-items .progress-item');
		lines.forEach(line => {
			line.classList.remove('active');
		});

		return lines;
	},
	
	setActiveClass(key) {
		this.resetItems()[key].classList.add('active');
		this.resetLines()[key].classList.add('active');
	},

	handleScroll() {
    	let controller = new ScrollMagic.Controller();
    	
		new ScrollMagic.Scene({
			triggerElement: '#home',
			triggerHook: 'onLeave'
		})
			.on('enter', () => this.setActiveClass(0))
			.on('leave', () => this.setActiveClass(0))
			//.addIndicators({name: 'intro'})
			.addTo(controller);

		new ScrollMagic.Scene({
			triggerElement: '#intro1',
			triggerHook: 'onLeave'
		})
			.on('enter', () => this.setActiveClass(1))
			.on('leave', () => this.setActiveClass(1))
			//.addIndicators({name: 'intro'})
			.addTo(controller);

    	new ScrollMagic.Scene({
			triggerElement: '#intro2',
			triggerHook: 'onLeave'
		})
			.on('enter', () => this.setActiveClass(2))
			.on('leave', () => this.setActiveClass(2))
			//.addIndicators({name: 'what-i-do'})
			.addTo(controller);

		new ScrollMagic.Scene({
			triggerElement: '#intro3',
			triggerHook: 'onLeave'
		})
			.on('enter', () => this.setActiveClass(3))
			.on('leave', () => this.setActiveClass(3))
			//.addIndicators({name: 'the-goods'})
			.addTo(controller);

		new ScrollMagic.Scene({
			triggerElement: '#intro4',
			triggerHook: 'onLeave'
		})
			.on('enter', () => this.setActiveClass(4))
			.on('leave', () => this.setActiveClass(4))
			//.addIndicators({name: 'contact'})
			.addTo(controller);
	}

};


// WEBPACK FOOTER //
// ./src/js/components/Navigation/animations.js